export var menuItems={
  "data": [
    
    {
      "path": "/",
      "title": "Dashboard",
      "icon": "stroke-board",
      "iconf":"fill-board",
      "icony":"fa fa-home",
      "type": "link",
      "active": false
    },

    {
      "path": "/products",
      "title": "Products",
      "icon": "stroke-internationalization",
      "iconf":"fill-internationalization",
      "icony":"icofont icofont-coins",
      "type": "link",
      "active": false
    },

    {
      "path": "/technicians",
      "title": "Technicians",
      "icon": "stroke-internationalization",
      "iconf":"fill-internationalization",
      "icony":"icofont icofont-engineer",
      "type": "link",
      "active": false
    },

    {
      "path": "/staffs",
      "title": "Staffs",
      "icon": "stroke-internationalization",
      "iconf":"fill-internationalization",
      "icony":"icofont icofont-users",
      "type": "link",
      "active": false
    },

    {
      "title": "Work Management",
      "icon": "stroke-internationalization",
      "iconf":"fill-internationalization",
      "icony":"icofont icofont-architecture-alt",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/job_management",
          "title": "Works",
          "type": "link",
          "active":false
        },
        {
          "path": "/enquiry_list",
          "title": "Enquiries",
          "type": "link",
          "active":false
        },
        {
          "path": "/job_requests",
          "title": "Work Requests",
          "type": "link",
          "active":false
        },
        {
          "path": "/cancellation_requests",
          "title": "Cancellation Requests",
          "type": "link",
          "active":false
        },
        {
          "path": "/company_titles",
          "title": "Company Titles",
          "type": "link",
          "active":false
        },
      ]
    },

    {
      "title": "Reports",
      "icon": "stroke-knowledgebase",
      "iconf":"fill-knowledgebase",
      "icony":"icon-files",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/product_stock_report",
          "title": "Product Stock Report",
          "type": "link",
          "active":false
        },
        {
          "path": "/work_report",
          "title": "Work Report",
          "type": "link",
          "active":false
        },
        {
          "path": "/earnings_report",
          "title": "Earnings Report",
          "type": "link",
          "active":false
        },
        {
          "path": "/technician_report",
          "title": "Technician Report",
          "type": "link",
          "active":false
        },
      ]
    },

    {
      "path": "/settings",
      "title": "Settings",
      "icon": "stroke-internationalization",
      "iconf":"fill-internationalization",
      "icony":"icon-settings",
      "type": "link",
      "active": false
    },
    
  ]
}